import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { getSign } from "@/api/dunhuang";
import { urlLink } from "@/utils/request";
const state = {
  shareUrl: "",
  timestamp: "",
  fingerId: "",
  answerQuestionScore: 0,
  answerNickName: "",
  userFlagList: [], //当前用户最终的的flag清单
  flagSignature: "", //flag签名
  aiShareCookbookId: null,
  aiGenerateNickName: null
};
const mutations = {
  SET_FINGERID: (state, fingerId) => {
    state.fingerId = fingerId;
  },
  SET_TIMESTAMP: (state, timestamp) => {
    state.timestamp = timestamp;
  },
  SET_SHARE_URL: (state, url) => {
    state.shareUrl = url;
  },
  SET_USER_SCORE: (state, score) => {
    state.answerQuestionScore = score;
  },
  SET_QUESTION_NIKE_NAME: (state, name) => {
    state.answerNickName = name;
  },
  SET_FLAG_LIST: (state, list) => {
    state.userFlagList = list;
  },
  SET_FLAG_SIGNATURE: (state, name) => {
    state.flagSignature = name;
  },
  SET_AISHARE_COOKBOOKID: (state, id) => {
    state.aiShareCookbookId = id;
  },
  SET_AISHARE_NICKNAME: (state, nickName) => {
    state.aiGenerateNickName = nickName;
  }
};

const actions = {
  async getShareUrl({ commit, state }) {
    const options = {
      excludes: { enumerateDevices: false }
    };
    const fp = await FingerprintJS.load(options);
    const result = await fp.get();
    const visitorId = result.visitorId;
    commit("SET_FINGERID", visitorId);
    var currentTimeStamp = Date.now();
    commit("SET_TIMESTAMP", currentTimeStamp);
    await getSign({
      shareFingerId: visitorId,
      timestamp: currentTimeStamp
    }).then(res => {
      if (res.code == 200) {
        const sign = res.data;
        //获取统一分享url
        const url = `${urlLink}/dunHuangHome?shareFingerId=${visitorId}&timestamp=${currentTimeStamp}&sign=${encodeURIComponent(
          sign
        )}`;
        commit("SET_SHARE_URL", url);
        localStorage.setItem(
          "fingerObj",
          JSON.stringify({
            fingerId: visitorId,
            timestamp: currentTimeStamp,
            shareUrl: url
          })
        );
        return "succ";
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/data.js